import React from "react";
import { StickyTopRowStack, StyledMainBox } from "../../../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../../../components/commonComponents/Hoc/AccessControl";
import Dashboard from "../../../../components/commonComponents/Embeddable/Dashboard";
import { Box, Chip } from "@mui/material";
import Filters from "../../Reports/Filters";
import { defineDashboardVariables } from "../../../../api_calls/ReportSettings";
import { checkUserDetailsFromCookie, checkUserRole } from "../../../../api_calls/userManagement";

const PreviewSingleDashLayout = ({ newDashboardConfig }) => {
    const [userInfo, setUserInfo] = React.useState({});
    const userRole = checkUserRole();
    let dashboardVariables = defineDashboardVariables(newDashboardConfig.tab_type, newDashboardConfig.section_name, newDashboardConfig.filter_config, userRole.user_role);

    React.useEffect(() => {
        const checkUserDetails = checkUserDetailsFromCookie();
        let userDetailObj = {};
        if (checkUserDetails.success === true) {
            userDetailObj = checkUserDetails.user_detail;
        }
        setUserInfo(userDetailObj);
    }, []);
    return (
        <StyledMainBox component="main" sx={{ padding: "10px 13px" }}>
            {/* ---------- filter section ------------- */}
            <Box
                width="100%"
                sx={{
                    position: "sticky",
                    top: "-20px",
                    zIndex: 999,
                    backgroundColor: "#fff",
                    borderBottom: 1,
                    borderColor: "divider",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        mb: 1,
                        mt: 1,
                        position: "sticky",
                    }}
                >
                    <Chip
                        label="Preview Mode"
                        sx={{
                            backgroundColor: "#AF3241",
                            color: "white",
                            fontWeight: "bold",
                            width: "200px",
                        }}
                    />
                </Box>
                <StickyTopRowStack direction={"row"} spacing={4} sx={{ top: "-20px" }}>
                    <Filters
                        configArr={newDashboardConfig.filter_config}
                        configTabName={newDashboardConfig.section_name}
                        configTabType={newDashboardConfig.tab_type}
                    />
                </StickyTopRowStack>
            </Box>



            <Box height={1} />
            {/* ------------ dashboard from tableau ------------ */}
            {typeof userInfo.root_company_id !== "undefined" && typeof newDashboardConfig.embeddable_section_id !== "undefined" && (
                <Box>
                    <Dashboard
                        embedDashboardId={newDashboardConfig.embeddable_section_id}
                        variables={dashboardVariables}
                        filterConfig={{
                            "number_root": userInfo.root_company_id.toString(),
                        }} />
                </Box>
            )}
        </StyledMainBox>
    );
};

export default AccessControl(PreviewSingleDashLayout, [
    "campaign_reports_performance_can_view",
    "campaign_reports_impression_can_view",
], [], ["campaigns_section", "campaign_list"], "preview");
